<template>
  <div class="printer-downloads" @click.stop>
    <a :href="downloads.arm64" @click="$emit('download')">macOS · Apple Silicon (M series)</a>
    <a :href="downloads.intel" @click="$emit('download')">macOS · Intel</a>
  </div>
</template>

<script>
import { printerDownloads } from '../printer'

export default {
  name: 'PrinterDownloads',
  data() {
    return { downloads: printerDownloads }
  }
}
</script>

<style scoped>
.printer-downloads {
  width: 240px;
  margin: 0 auto 10px;
  font-size: 13px;
  text-align: center;
}
.printer-downloads a {
  display: block;
  padding: 10px 4px;
  margin-bottom: 6px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #1769aa;
  text-decoration: none;
}
.printer-downloads a:hover,
.printer-downloads a:focus {
  background: #edf5fc;
}
</style>
